//Importaciones
import React from 'react'
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import CLabel from '../../../../Common/CLabel';
import FishboneChartSimple from './FishboneSimple';





function FishboneMiniToPanel(props) {
    //Helpers
    const { t } = useTranslation();

    const {
        inputParam_FishboneData = null,
    } = props;

    //Parametros de componente.

    //Render de componente.
    return <>
            <Row className="pt-3 pb-3">
                <Col xl={12}>
                    <CLabel labelText={t('data-lang-lbl-name')} labelValue={inputParam_FishboneData.name} />
                </Col>
                <Col xl={12}>
                    <CLabel labelText={t('data-lang-lbl-description')} labelValue={inputParam_FishboneData.description} />
                </Col>
                <Col xl={12} className="pt-2 fishboneParent">
                    <FishboneChartSimple data={inputParam_FishboneData.objNew}  />
                </Col>
            </Row>
    </>;
}

///Proptypes
FishboneMiniToPanel.propTypes = {
    inputParam_FishboneData: PropTypes.object.isRequired,
};

export default FishboneMiniToPanel;